import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0221',
    ecrans: ['00-2']
});
